import React, { useState, useRef, useEffect, useCallback } from "react";
import { Avatar, Button, Dropdown, Select, Spin, Tag, Tooltip, Upload, message } from "antd";
import Modal from "react-modal";
// import "./chat.css";
import bot from "../../assets/bot.png";
import ReactMarkdown from "react-markdown";
import profilePic from "../../assets/profile_pic.png";
import AAPALOGO from "../../assets/aapaNewlogoTm.png";
import clairaLogo from "../../assets/clairaLogo.jpeg";
import clairaLogoSvg from "../../assets/ClairaAdvAvatar.svg";

import {
  SendOutlined,
  PaperClipOutlined,
  MoreOutlined,
  CloseOutlined,
  LogoutOutlined,
  MinusOutlined,
  MessageOutlined,
  FormOutlined,
  InboxOutlined,
  CheckCircleOutlined,
  BarChartOutlined,
  WechatOutlined,
  WechatWorkOutlined,
  UploadOutlined,
  DownOutlined,
} from "@ant-design/icons";

import axios from "axios";
// import useChatSocket from '../../hooks/useBotListener.js'
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import Carousel from "../carousel/Carousel";
import { store } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { Ai_Base_Url, BE_HOST, CHAT_BASE_URL } from "../../config/config";
import { Loader, MessageCircle } from "lucide-react";
import { axiosInstance } from "../../utils/axiosInterceptor";
import "./stylesChat.css"

const StaticAccounts = ({ selectedAccounts = [], accountMap }) => {
  const items = selectedAccounts.map((acctId) => ({
    key: acctId,
    label: accountMap[acctId] || acctId,
    disabled: true,
  }));

  return (
    <div className="w-full flex justify-end">
      <Dropdown
        // menu={{ items }}
        trigger={["click"]}
        placement="bottomRight"
        overlayClassName="static-accounts-dropdown"
        menu={{
         items,
         style: {
           maxHeight: "200px",
           overflowY: "auto",
         },
      }}
      >
        <div
          style={{
            minWidth: "250px",
            border: "1px solid #fff",
            borderRadius: "6px",
            padding: "2px 12px",
            color: "#fff",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize:"16px"
          }}
        >
          <span>Current Selected Accounts</span>
          <DownOutlined />
        </div>
      </Dropdown>
    </div>
  );
};

const ManagementDashboardChat = ({ open, setOpen, gprData, memberPerData}) => {
  const [inputValue, setInputValue] = useState("");
  const chatContainerRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(true);
  const [autoScroll, setAutoScroll] = useState(true);
  const messagesContainerRef = useRef(null);
  const prevMessageCountRef = useRef(0);
  const [lang, setLang] = useState("en");
  const [isImageAttach, setIsAttachImage] = useState(false);
  const [attchedImage, setAttachedImage] = useState("");
  const [chatVisible, setChatVisible] = useState(false);
  const [talkToAgent, setTalkToAgent] = useState(false);
  const [isBotTyping,setIsBotTyping] = useState(false);
  const [isUserTyping, setIsUserTyping] = useState(false);
  const RoomId = JSON.parse(localStorage.getItem("MGMTRoomId"));
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const isAgentActive = JSON.parse(localStorage.getItem("isAgentActive"));
  const loginToken = localStorage.getItem("token");
  const [checkboxValues, setCheckboxValues] = useState({});
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isAccountChanged,setIsAccountChanged] = useState(false)


  const SelectedPharmacy = useSelector((state) => {
    return state.pharmacyData?.pharmacyData;
  });
  const pharmacylabel = useSelector((state) => {
    return state.pharmacyData?.pharmacyLabel;
  });

  const idleTimerRef = useRef(null);

  const [messages, setMessages] = useState([
  ]);

  const messagesEndRef = useRef(null);
  const prevPharmacyRef = useRef([]);

  const scrollToBottom = () => {
    messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

    const handleClose = () => {
    setOpen(false);
    localStorage.removeItem("MGMTRoomId")
    setMessages([]);
    setIsBotTyping(false);
  };




//   useEffect(()=>{
//     const prev = prevPharmacyRef.current;

//   const isChanged =
//     prev.length !== SelectedPharmacy.length ||
//     prev.some((item, index) => item !== SelectedPharmacy[index]);

//   if (isAccountChanged && isChanged && !UserId) {
//     console.log("Pharmacy Changed");
//     handleSend("chatsupport2", true);
//   }
//   prevPharmacyRef.current = [...SelectedPharmacy];
//   },[SelectedPharmacy])

  const handleSend = (item, flag) => {
    if (!inputValue?.trim() && !item) return;
    // resetIdleTimer();
    setIsUserTyping(true);
    const messageToSend = inputValue || item?.label || item;
    setInputValue("");
    // if (UserId) {
      AiChatSend(messageToSend, flag);
    // }
    setTimeout(scrollToBottom, 100);
  };

  const AiChatSend = async (msg, flag) => {
    if (!flag) {
      setIsBotTyping(true);
    }
    const newMsg = {
      message_id: "",
      msg: msg,
      rid: "",
      ts: new Date().toISOString(),
      u: {
        _id: "",
        name: userInfo?.user?.first_name,
        username: userInfo?.user?.email,
      },
    };
    if (!flag) {
      setMessages((prevMessages) => [...prevMessages, newMsg]);
    }
    const roomId = RoomId ? RoomId : "";
    const payload = {
      question: msg,
    //   primary_account_id: SelectedPharmacy,
      rid: RoomId,
      user_id: userInfo?.user?.id,
      username: userInfo?.user?.email,
      name: userInfo?.user?.first_name,
      token : loginToken,
      membership_summary_response: memberPerData,
      gpr_detail_response:gprData
    };
    try {
      const response = await axiosInstance.post(`${BE_HOST}/api/management/interaction-ask-mgmt`, payload, {
        // headers: {
        //   "Content-Type": "application/json",
        //   "Authorization": "Basic aapa:Aapa@123"
        // },
      });
      setIsUserTyping(false);
      // dispatch(setIsBotTyping(true));
      if (!RoomId) {
        localStorage.setItem(
          "MGMTRoomId",
          JSON.stringify(response?.data?.data?.data?.rid),
        );
      }
      setTalkToAgent(response?.data?.data?.data?.talk_to_agent);
      getAllAiMessages(response?.data?.data?.data);
    } catch (error) {
      console.error(
        "Error fetching chat:",
        error.response?.data?.message || error.message,
      );
    } finally {
      setIsUserTyping(false);
      setIsAccountChanged(true)
    }
  };

  const getAllAiMessages = async (data) => {
    try {
      const response = await axiosInstance.get(
        `${BE_HOST}/api/management/interaction-history?rid=${data?.rid || RoomId}`,{
        // headers: {
        //   "Content-Type": "application/json",
        //   "Authorization": "Basic aapa:Aapa@123"
        // }
        }
      );
      setMessages(response?.data?.data?.data?.messages);
    //   if (UserId && Authtoken && RoomId) {
    //     getAllMessage();
    //   }
    } catch (error) {
      console.error(
        "Error fetching messages:",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      setIsBotTyping(false);
    }
  };

  useEffect(() => {
    const container = chatContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const atBottom =
        container.scrollHeight - container.scrollTop <=
        container.clientHeight + 50;
      setIsAtBottom(atBottom);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (
      (autoScroll && messages?.length > prevMessageCountRef.current) ||
      isBotTyping
    ) {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    prevMessageCountRef.current = messages.length;
  }, [messages, autoScroll, isBotTyping]);

 


  const isValidUSPhone = (phone) => {
    return /^(\+1\s?)?((\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}|(\(\d{3}\)|\d{3})[-.\s]?\d{4})$/.test(
      phone.trim(),
    );
  };

//   const isValidInput = () => {
//     const value = inputValue?.trim();
//     const inputType = supportSession?.input_type?.toLowerCase();

//     if (!value) return false;

//     if (["tel"].includes(inputType)) {
//       return isValidUSPhone(value);
//     }

//     if (["email"].includes(inputType)) {
//       return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
//     }
//     if (["date"].includes(inputType)) {
//       return (
//         /^\d{4}-\d{2}-\d{2}$/.test(value) ||
//         /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/.test(value)
//       );
//     }
//     if (["number"].includes(inputType)) {
//       return /^-?\d+(\.\d+)?$/.test(value);
//     }
//     if (["text"].includes(inputType)) {
//       if (value.length === 1 && /^\d$/.test(value)) {
//         return false;
//       }
//       return true;
//     }

//     return true;
//   };



  useEffect(() => {
    if (!open) return;
     if(RoomId){
      getAllAiMessages();
    }
    else {
      handleSend("chatsupport_management", true);
    }
  }, [open]);


  useEffect(() => {
    if (open || chatVisible) {
      setTimeout(() => {
        messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [open, chatVisible]);

  const closePreview = () => {
    setIsAttachImage(false);
  };

  const formatChatDate = (isoString) => {
    const date = new Date(isoString);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isSameDay = (d1, d2) =>
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();

    if (isSameDay(date, today)) return "Today";
    if (isSameDay(date, yesterday)) return "Yesterday";

    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };


//    const accountMap = React.useMemo(() => {
//       const map = {};
//       allAcounts?.forEach((acc) => {
//         map[acc.acct_id] = acc.name;
//       });
//       return map;
//     }, [allAcounts]);
  
  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={() => setOpen(false)}
        className="chat-modal w-[88%] md:w-[32%] outline-none"
        overlayClassName="chat-overlay"
        ariaHideApp={false}
      >
        <div className="chat-container">
          <>
            <div className="chat-header">
              <div className="flex justify-between w-full">
                <div className="w-[62%] flex justify-end">
                  <img
                    src={AAPALOGO}
                    alt="logo"
                    className="w-28 h-24 object-contain p-0 m-0"
                  />
                </div>

                <div>
                  <MinusOutlined
                    onClick={() => {
                      setOpen(false);
                      setIsBotTyping(false);
                    }}
                    className="dot-icon"
                    style={{
                      cursor: "pointer",
                      color: "#fff",
                      fontSize: "20px",
                    }}
                  />
                  <MoreOutlined
                    disabled
                    className="dot-icon"
                    style={{
                      cursor: "not-allowed",
                      color: "#fff",
                      fontSize: "20px",
                    }}
                  />
                  <LogoutOutlined
                    onClick={() => {
                        handleClose();
                    }}
                    style={{
                      cursor: "pointer",
                      color: "#fff",
                      fontSize: "20px",
                    }}
                  />
                </div>
              </div>

            </div>
            {isImageAttach ? (
              <div className="image-preview-bar">
                <button className="close-btn" onClick={closePreview}>
                  <CloseOutlined style={{ fontSize: 16, color: "#fff" }} />
                </button>
                <div className="preview-wrapper">
                  <img
                    src={attchedImage?.previewUrl}
                    alt="preview"
                    className="preview-image"
                  />
                </div>

                <button className="send-btn2">
                  <SendOutlined style={{ fontSize: 20, color: "#fff" }} />
                </button>
              </div>
            ) : (
              <>
                <div
                  ref={chatContainerRef}
                  className="chat-body chat-scroll-container"
                  style={{
                    flex: 1,
                    overflowY: "auto",
                    paddingTop: "16px",
                    display: "flex",
                    flexDirection: "column",
                    // gap: "12px",
                  }}
                >
                  {[...messages]
                    ?.sort((a, b) => new Date(a?.ts) - new Date(b?.ts))
                    .filter((m) => m?.msg && m?.msg?.trim() !== "")
                    ?.map((msg, index, arr) => {
                      const isUser =
                        msg?.u?._id === userInfo?.user?.id ||
                        msg?.u?.name === "guest" ||
                        userInfo?.user?.email === msg?.u?.username;
                      const sender = isUser ? "user" : "bot";
                      const AvatarURL = isUser ? profilePic : clairaLogoSvg;
                      const prevMsg = arr[index - 1];
                      const prevSender =
                        prevMsg?.u?._id === userInfo?.user?.id ||
                        prevMsg?.u?.name === "guest" ||
                        userInfo?.user?.email === prevMsg?.u?.username
                          ? "user"
                          : "bot";
                      const text = msg?.msg || "";
                      const time = new Date(msg?.ts).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      });
                      let fullMessage = text.trim();
                      fullMessage = fullMessage.replace(/```/g, "");

                      fullMessage = fullMessage.replace(
                        /(https?:\/\/[^\s]+)/g,
                        (url) => `[${url}](${url})`,
                      );
                      fullMessage = fullMessage.replace(/<br\s*\/?>/gi, "\n");

                      const showAvatar = index === 0 || sender !== prevSender;
                      const msgKey =
                        msg?._id ||
                        msg?.id ||
                        `${msg?.ts}-${(msg?.msg || "").slice(0, 20)}`;
                    //   const selectedIndexForThisMsg = choiceSelections[msgKey];
                    //   const isLocked = selectedIndexForThisMsg !== undefined;
                      const currentDate = new Date(msg?.ts);
                      const prevMessage = arr[index - 1];
                      const prevDate = prevMessage
                        ? new Date(prevMessage.ts)
                        : null;

                      const shouldShowDate =
                        index === 0 ||
                        currentDate.toDateString() !== prevDate?.toDateString();
                      return (
                        <>
                          {shouldShowDate && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "20px",
                                gap: "10px",
                              }}
                            >
                              <div
                                style={{
                                  flex: 1,
                                  height: 1,
                                  background: "#dcdcdc",
                                }}
                              ></div>
                              <span
                                style={{
                                  fontSize: 12,
                                  color: "#666",
                                  background: "#f5f5f5",
                                  padding: "4px 10px",
                                  borderRadius: 20,
                                }}
                              >
                                {formatChatDate(msg?.ts)}
                              </span>

                              <div
                                style={{
                                  flex: 1,
                                  height: 1,
                                  background: "#dcdcdc",
                                }}
                              ></div>
                            </div>
                          )}

                          <div
                            style={{
                              background: sender == "user" ? null : null,
                              marginBottom: sender == "user" ? "5px" : "5px",
                              // paddingBottom: 10,
                              // borderRadius:20,
                              borderTopLeftRadius:
                                index > 0 && sender !== prevSender ? 20 : 0,
                              borderTopRightRadius:
                                index > 0 && sender !== prevSender ? 20 : 0,
                              borderBottomRightRadius:
                                index > 0 && sender !== prevSender ? 20 : 0,
                              borderBottomLeftRadius:
                                index > 0 && sender !== prevSender ? 20 : 0,
                              width: sender == "user" ? "100%" : "76%",
                            }}
                          >
                            {fullMessage && (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  flexDirection:
                                    sender === "user" ? "row-reverse" : "row",
                                  alignItems: "flex-start",
                                  gap: 8,
                                  marginTop:
                                    index > 0 && sender !== prevSender
                                      ? 20
                                      : 10,
                                  marginLeft: 3,
                                }}
                              >
                                {showAvatar ? (
                                  <div
                                    style={{
                                      width: sender == "user" ? 45 : 55,
                                      height: sender == "user" ? 45 : 55,
                                      flexShrink: 0,
                                    }}
                                  >
                                    <Avatar
                                      src={AvatarURL}
                                      alt={sender}
                                      size={sender == "user" ? 45 : 55}
                                      style={{
                                        objectFit: "contain",
                                        flexShrink: 0,
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      // size={"large"}
                                    />
                                  </div>
                                ) : (
                                  <div style={{ width: 55 }} />
                                )}
                                <div
                                  style={{
                                    background:
                                      sender === "user" ? "#000437" : "#fff",
                                    padding: "8px 12px",
                                    borderTopLeftRadius: 25,
                                    borderTopRightRadius: 25,
                                    borderBottomRightRadius:
                                      sender === "user" ? 0 : 25,
                                    borderBottomLeftRadius:
                                      sender === "user" ? 25 : 0,
                                    // maxWidth: "65%",
                                    maxWidth: sender === "user" ? "65%" : "84%",
                                    // boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                                  }}
                                >
                                  <div
                                    style={{
                                      color:
                                        sender === "user" ? "#fff" : "#333",
                                      fontSize: 14,
                                      fontFamily: "Arial, sans-serif",
                                      direction: "ltr",
                                      textAlign: "left",
                                    }}
                                  >
                                    <ReactMarkdown
                                      children={fullMessage}
                                      remarkPlugins={[remarkGfm]}
                                      rehypePlugins={[
                                        rehypeRaw,
                                        rehypeSanitize,
                                      ]}
                                      components={{
                                        p: ({ node, ...props }) => (
                                          <p
                                            style={{
                                              margin: "8px 0",
                                              lineHeight: "1.6",
                                            }}
                                            {...props}
                                          />
                                        ),
                                        strong: ({ node, ...props }) => (
                                          <strong
                                            style={{ fontWeight: "bold" }}
                                            {...props}
                                          />
                                        ),
                                        em: ({ node, ...props }) => (
                                          <em
                                            style={{ fontStyle: "italic" }}
                                            {...props}
                                          />
                                        ),
                                        ul: ({ node, ...props }) => (
                                          <ul
                                            style={{
                                              paddingLeft: 20,
                                              margin: "8px 8px",
                                              listStyleType: "disc",
                                            }}
                                            {...props}
                                          />
                                        ),
                                        ol: ({ node, ...props }) => (
                                          <ol
                                            style={{
                                              paddingLeft: 20,
                                              margin: "8px 8px",
                                              listStyleType: "decimal",
                                            }}
                                            {...props}
                                          />
                                        ),
                                        li: ({ node, ...props }) => (
                                          <li
                                            style={{ marginBottom: 4 }}
                                            {...props}
                                          />
                                        ),
                                        a: ({ node, ...props }) => (
                                          <a
                                            style={{
                                              color:
                                                sender === "user"
                                                  ? "#aadfff"
                                                  : "#007bff",
                                              textDecoration: "underline",
                                              wordBreak: "break-word",
                                            }}
                                            {...props}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          />
                                        ),
                                        code: ({ node, ...props }) => (
                                          <code
                                            style={{
                                              background: "#f4f4f4",
                                              padding: "2px 4px",
                                              borderRadius: 4,
                                            }}
                                            {...props}
                                          />
                                        ),
                                        table: ({ node, ...props }) => (
                                          <div
                                            style={{
                                              overflowX: "auto",
                                              margin: "12px 0",
                                              width: "100%",
                                            }}
                                          >
                                            <table
                                              style={{
                                                borderCollapse: "collapse",
                                                width: "100%",
                                                minWidth: "400px",
                                                fontSize: "14px",
                                                fontFamily: "inherit",
                                              }}
                                              {...props}
                                            />
                                          </div>
                                        ),

                                        thead: ({ node, ...props }) => (
                                          <thead
                                            style={{
                                              backgroundColor:
                                                sender === "user"
                                                  ? "#1a6fa3"
                                                  : "#f0f4f8",
                                              color:
                                                sender === "user"
                                                  ? "#ffffff"
                                                  : "#222222",
                                            }}
                                            {...props}
                                          />
                                        ),

                                        tbody: ({ node, ...props }) => (
                                          <tbody {...props} />
                                        ),

                                        tr: ({ node, ...props }) => (
                                          <tr
                                            style={{
                                              borderBottom: "1px solid #e0e0e0",
                                              backgroundColor: "transparent",
                                            }}
                                            onMouseEnter={(e) =>
                                              (e.currentTarget.style.backgroundColor =
                                                "#f9f9f9")
                                            }
                                            onMouseLeave={(e) =>
                                              (e.currentTarget.style.backgroundColor =
                                                "transparent")
                                            }
                                            {...props}
                                          />
                                        ),

                                        th: ({ node, ...props }) => (
                                          <th
                                            style={{
                                              padding: "8px 12px",
                                              textAlign: "left",
                                              fontWeight: "600",
                                              fontSize: "12px",
                                              whiteSpace: "nowrap",
                                              borderBottom: "2px solid #cbd5e1",
                                            }}
                                            {...props}
                                          />
                                        ),

                                        // td: ({ node, ...props }) => (
                                        //   <td
                                        //     style={{
                                        //       padding: "7px 12px",
                                        //       textAlign: "left",
                                        //       whiteSpace: "nowrap",
                                        //       color:
                                        //         sender === "user"
                                        //           ? "#ffffff"
                                        //           : "#222",
                                        //       borderBottom: "1px solid #e5e7eb",
                                        //     }}
                                        //     {...props}
                                        //   />
                                        // ),

                                        td: ({ node, children, ...props }) => {
                                          const row =
                                            node?.parent?.children || [];

                                          // First column value (Metric)
                                          const metric =
                                            row?.[0]?.children?.[0]?.value?.trim() ||
                                            "";

                                          let value = children;

                                          // Don't format first column
                                          const isMetricColumn =
                                            node === row?.[0];

                                          if (!isMetricColumn) {
                                            const text = String(children);

                                            if (
                                              text !== "-" &&
                                              !isNaN(Number(text))
                                            ) {
                                              if (
                                                [
                                                  "Total Rx",
                                                  "Generic Rx",
                                                  "Brand Rx",
                                                ].includes(metric)
                                              ) {
                                                value = `$${Number(
                                                  text,
                                                ).toLocaleString(undefined, {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                })}`;
                                              }

                                              if (metric === "GCR %") {
                                                value = `${Number(text).toFixed(2)}%`;
                                              }
                                            }
                                          }

                                          return (
                                            <td
                                              style={{
                                                padding: "7px 12px",
                                                textAlign: "left",
                                                whiteSpace: "nowrap",
                                                color:
                                                  sender === "user"
                                                    ? "#ffffff"
                                                    : "#222",
                                                borderBottom:
                                                  "1px solid #e5e7eb",
                                              }}
                                              {...props}
                                            >
                                              {value}
                                            </td>
                                          );
                                        },
                                      }}
                                    />
                                  </div>
                                  {
                                    <div
                                      style={{
                                        fontSize: 10,
                                        textAlign: "right",
                                        color:
                                          sender === "user"
                                            ? "#d5dbd6"
                                            : "#888",
                                      }}
                                    >
                                      {time}
                                    </div>
                                  }
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      );
                    })}
                  {talkToAgent && (
                    <div
                      style={{
                        background: "#fff",
                        marginLeft: 62,
                        marginTop: 10,
                        padding: "10px",
                        borderRadius: "8px",
                        width: "64%",
                        textAlign: "center",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                      }}
                    >
                      <p
                        style={{
                          marginBottom: "12px",
                          fontSize: "14px",
                          lineHeight: "1.6",
                        }}
                      >
                        Please confirm, do you want to connect to an agent ?
                      </p>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            height: "32px",
                            padding: "0 14px",
                            background: "#4b5563", // soft gray
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "13px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "background 0.2s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.background = "#374151")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.background = "#4b5563")
                          }
                        //   onClick={() => handleChatLogin()}
                        >
                          Yes
                        </button>

                        <button
                          style={{
                            height: "32px",
                            padding: "0 14px",
                            background: "#e5e7eb", // light gray
                            color: "#111827",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "13px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "background 0.2s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.background = "#d1d5db")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.background = "#e5e7eb")
                          }
                          onClick={() => setTalkToAgent(false)}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  )}


                  <div ref={messagesEndRef} />
                </div>
                {isBotTyping ? (
                  <div
                    className="bot-typing-indicator"
                    style={{
                      padding: "12px 20px",
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <span style={{ fontSize: 14, color: "#888" }}>
                      Bot is typing
                    </span>
                    <span
                      className="typing-dots"
                      style={{ display: "flex", gap: 4 }}
                    >
                      <span
                        className="dot"
                        style={{
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          background: "#888",
                          animation: "bounce 1s infinite",
                        }}
                      />
                      <span
                        className="dot"
                        style={{
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          background: "#888",
                          animation: "bounce 1s infinite 0.2s",
                        }}
                      />
                      <span
                        className="dot"
                        style={{
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          background: "#888",
                          animation: "bounce 1s infinite 0.4s",
                        }}
                      />
                    </span>
                  </div>
                ) : (
                  <div className="chat-input">
                    {/* <button className="icon-btn" disabled={isBotTyping}>
                      <PaperClipOutlined style={{ fontSize: 20 }} />
                    </button> */}

                    <input
                      disabled={isBotTyping}
                      type="text"
                      placeholder={"Type your question here..."}
                      value={inputValue}
                      className="w-[40%]"
                      onChange={(e) => {
                        // resetIdleTimer();
                        setInputValue(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSend();
                      }}
                      style={{
                        direction: lang === "ar" ? "rtl" : "ltr",
                        textAlign: lang === "ar" ? "right" : "left",
                      }}
                    />
                    <button
                      disabled={isBotTyping}
                      className="send-btn"
                      onClick={handleSend}
                    >
                      <SendOutlined style={{ fontSize: 20, color: "white" }} />
                    </button>
                  </div>
                )}
              </>
            )}
          </>
          {/* )} */}
        </div>
      </Modal>
    </>
  );
};

export default ManagementDashboardChat;
